import axios from 'axios'
let BASE_URL = ''

if(location.hostname == 'localhost'){
    BASE_URL = 'http://www.gdir.local/admin/'
}else if(location.hostname == 'dmsiriusxm4biz.com'){
    BASE_URL = 'https://sxbr3api.dmsiriusxm4biz.com/admin/'
}else if(location.hostname == 'latest.dmsiriusxm4biz.com'){
    BASE_URL = 'https://latestsxbr3api.dmsiriusxm4biz.com/admin/'
}else if(location.hostname == 'siriusxm4biz.com' || location.hostname == 'www.siriusxm4biz.com'){
    BASE_URL = 'https://sxbr3api.siriusxm4biz.com/admin/'
}else if(location.hostname == 'old.siriusxm4biz.com'){
    BASE_URL = 'https://sxbr3api.gracedigital.com/admin/'
}

const axiosAdmin = axios.create({
    baseURL:BASE_URL
})

export default axiosAdmin